<template>
  <div class="opportunity-resolve-blocked column content-box">
    <woot-modal-header
      :header-title="$t('CONVERSATION.RESOLVE_BLOCKED_BY_OPPORTUNITY.TITLE')"
    />

    <div class="modal-content">
      <div class="opportunity-resolve-blocked__alert">
        <fluent-icon icon="warning" size="24" />
        <div>
          <p
            v-dompurify-html="
              $t('CONVERSATION.RESOLVE_BLOCKED_BY_OPPORTUNITY.MESSAGE', {
                name: opportunity.name,
                value: formattedValue,
              })
            "
          />
          <p>
            <strong>{{
              $t('CONVERSATION.RESOLVE_BLOCKED_BY_OPPORTUNITY.INSTRUCTION')
            }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div class="modal-footer opportunity-resolve-blocked__footer">
      <woot-button variant="clear" @click="$emit('close')">
        {{ $t('CONVERSATION.RESOLVE_BLOCKED_BY_OPPORTUNITY.CLOSE') }}
      </woot-button>
      <router-link class="button nice" :to="opportunityDetailsRoute">
        {{ $t('CONVERSATION.RESOLVE_BLOCKED_BY_OPPORTUNITY.VIEW_OPPORTUNITY') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { formatCurrencyValue } from 'dashboard/helper/opportunityDashboardHelper';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  props: {
    opportunity: { type: Object, required: true },
  },
  computed: {
    formattedValue() {
      return formatCurrencyValue(
        this.opportunity.value,
        this.opportunity.currency
      );
    },
    opportunityDetailsRoute() {
      return frontendURL(
        `accounts/${this.$route.params.accountId}/opportunities/${this.opportunity.id}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
.opportunity-resolve-blocked__alert {
  align-items: flex-start;
  background: var(--r-50);
  border: 1px solid var(--r-100);
  border-radius: var(--border-radius-normal);
  display: flex;
  gap: var(--space-normal);
  padding: var(--space-normal);

  svg {
    color: var(--r-800);
    flex-shrink: 0;
    margin-top: var(--space-micro);
  }

  p {
    color: var(--b-900);
    font-size: var(--font-size-small);
    line-height: 1.5;
    margin: 0;

    strong {
      font-weight: var(--font-weight-bold);
    }

    & + p {
      margin-top: var(--space-small);
    }
  }
}

.opportunity-resolve-blocked__footer {
  justify-content: flex-end !important;
  padding: var(--space-large) !important;
  width: 100%;
}
</style>
